module.exports = __webpack_public_path__ + "img/logo8.13980be1.png";